import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, ShoppingCart, User } from 'lucide-react';
import { getCart } from '../utils/cartApi';

const BottomNav = () => {
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);

  const refreshCartCount = async () => {
    try {
      const cart = await getCart();
      const count = cart.items?.reduce((acc, item) => acc + item.quantity, 0) || 0;
      setCartCount(count);
    } catch (err) {
      console.error('BottomNav cart load failed:', err);
    }
  };

  useEffect(() => {
    refreshCartCount();
    window.addEventListener('cartUpdated', refreshCartCount);
    return () => window.removeEventListener('cartUpdated', refreshCartCount);
  }, []);

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { name: 'Home', path: '/', icon: Home },
    { name: 'Explore', path: '/explore', icon: Compass },
    { name: 'Cart', path: '/cart', icon: ShoppingCart },
    { name: 'Login', path: '/login', icon: User },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-[#3d2b1f]/10">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center w-full h-full relative transition-colors ${
                active
                  ? 'text-[#3d2b1f] border-t-2 border-[#3d2b1f]'
                  : 'text-[#999] hover:text-[#3d2b1f]'
              }`}
            >
              <div className="relative">
                <Icon size={24} />
                {item.path === '/cart' && cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-[#3d0c11] text-white text-[10px] px-1.5 py-0.5 rounded-full font-bold">
                    {cartCount}
                  </span>
                )}
              </div>
              <span className="text-[10px] mt-1 font-bold">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
